import axios from '@/utils/request'

export default {
  //2020-07-23
  sendVerificationCode(params) {
    return axios.post('/weixin/send-vcode', params)
  }

}
